import { createSelector } from 'reselect';

const selectMarketingText = state => state.marketingText;

const selectMarketingTextByNamespace = ({ marketingText }, namespace = 'default') => {
  const { namespaceDefaults } = marketingText;
  return marketingText[`namespace-${namespace}`] || namespaceDefaults;
};

export const selectMarketingTextConfig = createSelector(
  selectMarketingText,
  marketingText => marketingText.config,
);

export const makeSelectMarketingTextData = () => (
  createSelector(
    selectMarketingTextByNamespace,
    ({ data }) => data,
  )
);

export const makeSelectMarketingTextIsLoading = () => (
  createSelector(
    selectMarketingTextByNamespace,
    ({ isLoading }) => isLoading,
  )
);

export const makeSelectMarketingTextIsLoaded = () => (
  createSelector(
    selectMarketingTextByNamespace,
    ({ isLoaded }) => isLoaded,
  )
);

export const makeSelectMarketingTextResponseDate = () => (
  createSelector(
    selectMarketingTextByNamespace,
    ({ responseDate }) => responseDate,
  )
);
